import { createAction } from "@reduxjs/toolkit";

import type {
  PutApplicationMetadataUpdateRequestBody,
  PutApplicationUpdateRequestBody,
} from "@superblocksteam/schemas";
import type { ApplicationV2GlobalDto } from "@superblocksteam/shared";

import type ApplicationApi from "legacy/api/ApplicationApi";

export const fetchApplicationSuccess = createAction(
  "FETCH_APPLICATION_SUCCESS",
  (
    application: Awaited<
      ReturnType<typeof ApplicationApi.fetchSingleApplication>
    >["data"]["application"] & {
      global?: Partial<ApplicationV2GlobalDto>;
    },
  ) => ({ payload: application }),
);

export const updateApplication = createAction(
  "UPDATE_APPLICATION",
  (
    id: string,
    branch: string | undefined,
    data: Partial<PutApplicationUpdateRequestBody>,
  ) => {
    return {
      payload: {
        id,
        branch,
        ...data,
      },
    };
  },
);

export const updateApplicationMetadata = createAction(
  "UPDATE_APPLICATION_METADATA",
  (
    id: string,
    data: PutApplicationMetadataUpdateRequestBody,
    disableNotification?: boolean,
  ) => ({
    payload: { id, ...data, disableNotification },
  }),
);
